import { render, staticRenderFns } from "./publishOptionManage.vue?vue&type=template&id=04add7ce&scoped=true&"
import script from "./publishOptionManage.vue?vue&type=script&lang=js&"
export * from "./publishOptionManage.vue?vue&type=script&lang=js&"
import style0 from "./publishOptionManage.vue?vue&type=style&index=0&id=04add7ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04add7ce",
  null
  
)

export default component.exports